// extracted by mini-css-extract-plugin
module.exports = {"calculatingMessage":"productDetailClientPage_calculatingMessage__sbVdf","calculatingMessageActive":"productDetailClientPage_calculatingMessageActive__l_ghP"};